/** Marker attribute for Playwright to mask live countdown UI in visual regression screenshots. */
export const VISUAL_REGRESSION_MASK = 'data-visual-regression-mask';
